import { useEffect } from "react";

export default function useRevealOnScroll(ref) {
  useEffect(() => {
    const container = ref.current;

    if (!container) {
      return undefined;
    }

    const revealNodes = [...container.querySelectorAll(".reveal")];

    if (!revealNodes.length) {
      return undefined;
    }

    if (!("IntersectionObserver" in window)) {
      revealNodes.forEach((node) => node.classList.add("visible"));
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.08, rootMargin: "0px 0px -30px 0px" },
    );

    revealNodes.forEach((node) => observer.observe(node));

    return () => observer.disconnect();
  }, [ref]);
}
